module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/convenios/listado/convenios-listado.component.scss
// module id = ./src/app/convenios/listado/convenios-listado.component.scss
// module chunks = main